import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { Wrap } from "@chakra-ui/layout";
import { Text, Flex, Image, WrapItem, Box, Skeleton } from "@chakra-ui/react";
import React from "react";
import { useAppDispatch } from "../../../Store/hooks";
import Loader from "../../Helpers/Loader";
import { ModalsName, setModalOpen } from "../../../Store/ModalsReducer";
import CoveringMasterImage from "../../Images/coveringMaster.jpg";

const LOAD_ALL = gql`
  query LoadAll($type: String!) {
    loadAll(type: $type) {
      items {
        id
        name
        preview
      }
    }
  }
`;

const LOAD_ONE = gql`
  query LoadOne($type: String!, $id: Int!) {
    loadOne(type: $type, id: $id) {
      id
      path3D {
        dirname
        obj
        mtl
      }
    }
  }
`;

type ModelMini = {
  id: string;
  name: string;
  preview: string;
  addModel: (
    data: {
      dirname: string;
      obj: string;
      mtl: string;
    },
    category: string,
    id: number
  ) => void;
};

const Item = (props: ModelMini & { category: string }) => {
  const dispatch = useAppDispatch();
  const [loadItem, { loading, error, data }] = useLazyQuery(LOAD_ONE, {
    onCompleted: () => {
      dispatch(setModalOpen({ key: ModalsName.ADD, value: false }));
      props.addModel(
        data.loadOne.path3D,
        props.category,
        parseInt(props.id, 10)
      );
    },
    onError: (err) => {
      console.log(err, error);
    },
  });

  return (
    <WrapItem
      onClick={() =>
        loadItem({
          variables: {
            type: props.category,
            id: props.id,
          },
        })
      }
    >
      <Box w={200} h={175} textAlign="center" border="#333 1px solid">
        {loading ? (
          <Flex h={200}>
            <Loader />
          </Flex>
        ) : (
          <>
            <Text w={198} h={25} bg="#333" color="white" fontWeight="bold">
              {props.name}
            </Text>
            <Box w={198} h={148} align="center">
              <Image
                src={props.preview}
                alt={props.name}
                w={198}
                h={148}
                fallback={<Skeleton w={200} h={150} />}
              />
            </Box>
          </>
        )}
      </Box>
    </WrapItem>
  );
};

const Level = (props: {
  next: () => void;
  category: string;
  addModel: (
    data: {
      dirname: string;
      obj: string;
      mtl: string;
    },
    category: string,
    id: number
  ) => void;
}) => {
  const { loading, error, data } = useQuery(LOAD_ALL, {
    variables: {
      type: props.category,
    },
  });
  return (
    <Box>
      {loading && (
        <Wrap justify="space-evenly">
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
          <Skeleton w={200} h={175}></Skeleton>
        </Wrap>
      )}
      {error && <span>{error}</span>}
      {!loading && data && (
        <Wrap justify="space-evenly">
          {data.loadAll.items.map((item: ModelMini) => (
            <Item
              {...item}
              key={`${props.category}${item.id}`}
              category={props.category}
              addModel={props.addModel}
            />
          ))}
          {props.category === "covering" && (
            <WrapItem onClick={props.next}>
              <Box w={200} h={175} textAlign="center" border="#333 1px solid">
                {loading ? (
                  <Flex h={200}>
                    <Loader />
                  </Flex>
                ) : (
                  <>
                    <Text
                      w={198}
                      h={25}
                      bg="#333"
                      color="white"
                      fontWeight="bold"
                    >
                      Создать свое
                    </Text>
                    <Box w={198} h={148} align="center">
                      <Image
                        src={CoveringMasterImage}
                        alt={"Создать свое покрытие"}
                        w={198}
                        h={148}
                        fallback={<Skeleton w={200} h={150} />}
                      />
                    </Box>
                  </>
                )}
              </Box>
            </WrapItem>
          )}
        </Wrap>
      )}
    </Box>
  );
};

export default Level;
